
import React from 'react';

interface ConsultorioServicesProps {
  servicos: string[];
  destaces: string[];
}

export const ConsultorioServices: React.FC<ConsultorioServicesProps> = ({ servicos, destaces }) => {
  return (
    <>
      {/* Serviços */}
      <div className="mb-6">
        <h3 className="font-semibold font-accent text-gray-800 mb-3 text-sm sm:text-base">Serviços Disponíveis</h3>
        <div className="flex flex-wrap gap-2">
          {servicos.map((servico, idx) => (
            <span 
              key={idx}
              className="bg-brand-primary/10 text-brand-primary px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-text border border-brand-primary/20"
            >
              {servico}
            </span>
          ))}
        </div>
      </div>

      {/* Destaques */}
      <div className="mb-6">
        <h3 className="font-semibold font-accent text-gray-800 mb-3 text-sm sm:text-base">Destaques</h3>
        <div className="flex flex-wrap gap-2">
          {destaces.map((destaque, idx) => (
            <span 
              key={idx}
              className="bg-blue-100 text-blue-800 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-text border border-blue-200"
            >
              {destaque}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};
